/** Sync with app.version.properties / android flavors on each store upload. */
export const LATEST_STAFF_APP_VERSION = '2.0';

export const SHIPPED_APP_RELEASES = {
  customer: { version: '2.0', build: 26 },
  mechanic: { version: '2.0', build: 21 },
  staff: { version: '2.0', build: 27 },
};

export function compareAppVersions(a, b) {
  const parse = (v) =>
    String(v || '')
      .trim()
      .split(/[^\d]+/)
      .filter(Boolean)
      .map((n) => parseInt(n, 10) || 0);
  const pa = parse(a);
  const pb = parse(b);
  const len = Math.max(pa.length, pb.length, 1);
  for (let i = 0; i < len; i += 1) {
    const d = (pa[i] || 0) - (pb[i] || 0);
    if (d) return d < 0 ? -1 : 1;
  }
  return 0;
}

export function formatAppVersionBadge(user) {
  const version = user?.app_version;
  const build = user?.app_build_number;
  if (!version) {
    return { label: 'Not reported', className: 'bg-gray-100 text-gray-600' };
  }
  const label = build ? `${version} (${build})` : version;
  const isLatest = version === LATEST_STAFF_APP_VERSION;
  return {
    label,
    className: isLatest
      ? 'bg-emerald-50 text-emerald-700'
      : 'bg-amber-50 text-amber-800',
    isLatest,
  };
}

export function formatAppPlatform(platform) {
  const p = String(platform || '').trim().toLowerCase();
  if (p === 'ios') {
    return { label: 'iOS', className: 'bg-slate-100 text-slate-700 ring-slate-500/15' };
  }
  if (p === 'android') {
    return { label: 'Android', className: 'bg-emerald-50 text-emerald-800 ring-emerald-600/15' };
  }
  if (p === 'web') {
    return { label: 'Web', className: 'bg-blue-50 text-blue-700 ring-blue-600/15' };
  }
  return null;
}

export function formatVersionReportedAt(value) {
  if (!value) return '—';
  try {
    return new Date(value).toLocaleString('en-IN', {
      day: '2-digit',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return '—';
  }
}
